module.exports = __webpack_public_path__ + "static/media/logo.3e2d3b45.png";